module.exports = __webpack_public_path__ + "static/media/settings.85826047.png";